import { render } from "./HeroiconsSolidAcademicCap.vue?vue&type=template&id=f9bdc752"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidAcademicCap.vue"]])

export default __exports__